import { Controller } from "@hotwired/stimulus";
import * as common from "@/javascripts/common.js";
import { FetchRequest } from "@rails/request.js";
import { format, subDays } from "date-fns";
import { ja } from "date-fns/locale";

// Connects to data-controller="promoters--events--performances--receptions"
export default class extends Controller {
  static targets = [
    "refererForm",
    "accessSettingForm",
    "salesType",
    "receptionAttributes",
    "cvsSalesEndAt",
    "prefectureForm",
    "prefectureCheckbox",
    "eventForm",
    "eventCheckbox",
    "ticketId",
    "salesEndOn",
  ];
  static values = {
    checkedSalesType: String,
    updateLotteryDatesUrl: String,
    updateLotteryDatesMethod: String,
    eventDateFrom: String,
  };

  connect() {
    if (this.hasPrefectureCheckboxTarget) {
      this.deactivateSelectedPrefecture();
    }
  }

  refererFormSubmit(event) {
    event.preventDefault();
    const btn = event.currentTarget;
    this.refererFormTarget.requestSubmit();
    btn.disabled = true;
    common.HtmlScroll();
  }

  accessSettingFormSubmit(event) {
    event.preventDefault();
    const btn = event.currentTarget;
    this.accessSettingFormTarget.requestSubmit();
    btn.disabled = true;
    common.HtmlScroll();
  }

  // frameIdを持つ要素をクリア
  clearFrame(frameId) {
    const frame = document.getElementById(frameId);
    frame.innerHTML = "";
  }

  // ドロワーを開く
  openDrawer(event) {
    this.clearFrame(event.currentTarget.dataset.frameId);
    this.externalControllerAction(event, "drawer", "open");
  }

  // 外部コントローラーのアクションを呼び出す
  externalControllerAction(event, identifier, action) {
    const targetId = event.currentTarget.dataset.targetId;
    const controller = this.application.getControllerForElementAndIdentifier(
      document.getElementById(targetId),
      identifier,
    );
    controller[action]();
  }

  // 選択する前の状態に戻す
  noChangeSalesType(e) {
    this.checkedSalesTypeValue = e.target.value;
    this.salesTypeTargets.forEach((target) => {
      target.checked = target.dataset.beforeValue === "true" ? true : false;
    });
  }

  removeReceptionAttributes() {
    this.salesTypeTargets.forEach((target) => {
      if (target.value === this.checkedSalesTypeValue) {
        target.checked = true;
        target.dataset.beforeValue = true;
      } else {
        target.dataset.beforeValue = false;
      }
    });
    // チケットの選択を解除
    for (const ticketId of this.ticketIdTargets) {
      ticketId.checked = false;
    }
    // 販売受付画面の入力内容を削除
    const attributes = this.receptionAttributesTarget;
    while (attributes.firstChild) {
      attributes.removeChild(attributes.firstChild);
    }
  }

  setCvsSalesEndAt() {
    if (!this.hasCvsSalesEndAtTarget) return;
    const salesEndType = document.querySelector('input[name="reception_form[sales_end_type]"]:checked').value;
    // 「イベント開催日時まで販売」の場合は開催日、「日時を指定する」の場合は入力した日付
    const input_value = salesEndType === "until_event_start" ? this.eventDateFromValue : this.salesEndOnTarget.value;

    if (input_value) {
      const targetDate = subDays(new Date(input_value), 2);
      // コンビニ決済受付終了を設定する
      this.cvsSalesEndAtTarget.textContent = format(targetDate, "yyyy/MM/dd(EEE) 23:59", { locale: ja });
    } else {
      // 販売終了が未入力に変更された場合、コンビニ決済受付終了の内容を削除する
      this.cvsSalesEndAtTarget.textContent = "";
    }
  }

  // 地域（都道府県）を選択ドロワーの送信処理
  prefectureDrawerSubmit(event) {
    event.preventDefault();
    this.prefectureFormTarget.requestSubmit();
    this.deactivateSelectedPrefecture();
  }

  // 選択済みの都道府県を非活性化する
  deactivateSelectedPrefecture() {
    this.prefectureCheckboxTargets.forEach((checkbox) => {
      if (checkbox.checked && !checkbox.disabled) {
        const hiddenInput = Object.assign(document.createElement("input"), {
          type: "hidden",
          id: `selected_prefecture_${checkbox.value}`,
          name: checkbox.name,
          value: checkbox.value,
        });
        this.prefectureFormTarget.appendChild(hiddenInput);
        checkbox.disabled = true;
      }
    });
  }

  // 選択された都道府県の削除
  deletePrefecture(event) {
    event.preventDefault();

    const prefectureElement = event.currentTarget.parentNode;
    const hiddenInput = prefectureElement.querySelector('input[type="hidden"]');
    const prefectureId = hiddenInput ? hiddenInput.value : null;

    if (prefectureId) {
      const checkbox = document.querySelector(
        `input[type="checkbox"][id="reception_form_prefecture_ids_${prefectureId}"]`,
      );
      const hiddenValue = document.querySelector(`input[type="hidden"][id="selected_prefecture_${prefectureId}"]`);

      if (checkbox) {
        checkbox.checked = false;
        checkbox.disabled = false;
      }
      if (hiddenValue) {
        hiddenValue.remove();
      }
    }

    prefectureElement.remove();
  }

  // 抽選期間開始日、終了日を更新する
  async updateLotteryDates(event) {
    const url = this.updateLotteryDatesUrlValue;
    const method = this.updateLotteryDatesMethodValue;
    const req = new FetchRequest(method, url, {
      body: new FormData(event.currentTarget.form),
      responseKind: "turbo-stream",
    });
    const res = await req.perform();
    if (!res.ok) console.debug(res);
  }
}
